import { WithCopy } from 'components/shared/WithCopy/WithCopy';
import { FC, useCallback, useContext, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import { OpenModalButton } from './OpenModalButton';

export type ValueForMoneyProps = {
  className?: string;
  tabId: string;
  containerId: string;
  rawValueForMoney: string;
};

export const ValueForMoney: FC<ValueForMoneyProps> = ({ className, containerId, tabId, rawValueForMoney }) => {
  const { formatMessage } = useIntl();
  const [isRawValueForMoneyModalDisplayed, setIsRawValueForMoneyModalDisplayed] = useState(false);
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);

  const onRawValueForMoneyTrigger = useCallback(() => {
    setIsRawValueForMoneyModalDisplayed(!isRawValueForMoneyModalDisplayed);
    logAnalytics.trackEvent(logAnalyticsCategory, 'Raw value for money');
  }, [isRawValueForMoneyModalDisplayed, logAnalyticsCategory]);

  const rawValueForMoneyModalId = 'raw-value-for-money-modal';

  const indentedRawValueForMoney = JSON.stringify(JSON.parse(rawValueForMoney), null, 2);

  return (
    <>
      <OpenModalButton className={className} onClick={onRawValueForMoneyTrigger} />
      <Modal
        backdrop="static"
        className={`${rawValueForMoneyModalId}-component`}
        fade
        centered
        show={isRawValueForMoneyModalDisplayed}
        size="xl"
      >
        <ModalHeader>
          <ModalTitle as="h4">
            <div className="d-flex">
              {formatMessage({ id: 'sidePanel.modal.rawValueForMoney.title' })}
              <WithCopy
                content={indentedRawValueForMoney}
                toastSuccessMessage="copyToClipboard.valueForMoney.success"
                toastErrorMessage="copyToClipboard.valueForMoney.error"
              >
                <button
                  className="btn btn-sm btn-flat-secondary ms-2"
                  data-e2e="value-for-money-copy-button"
                  type="button"
                  title={formatMessage({ id: 'moreMenu.copyToClipboard' })}
                >
                  <i className="icon">file_copy</i>
                </button>
              </WithCopy>
            </div>
          </ModalTitle>
        </ModalHeader>

        <ModalBody className="py-0">
          <div id={containerId + tabId}>
            <pre className="text-primary pre-scrollable bg-lvl2">{indentedRawValueForMoney}</pre>
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            className="btn btn-xl btn-default"
            data-e2e="close-raw-value-for-money-modal"
            onClick={onRawValueForMoneyTrigger}
          >
            {formatMessage({ id: 'close' })}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ValueForMoney.displayName = 'ValueForMoney';
